// src/config/allowedTypes.js

export const allowedTypesConformity = {
    image: ["image/jpeg", "image/png"],
    pdf: ["application/pdf"],
  };
  
  export const maxFileSizeConformityMB = {
    image: 5, // máximo 5 MB para imágenes
    pdf: 10,  // máximo 10 MB para PDFs
  };